import { render } from "./app-modal-invoice-view.vue?vue&type=template&id=3ef4c827&scoped=true"
import script from "./app-modal-invoice-view.vue?vue&type=script&lang=js"
export * from "./app-modal-invoice-view.vue?vue&type=script&lang=js"

import "./app-modal-invoice-view.vue?vue&type=style&index=0&id=3ef4c827&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef4c827"]])

export default __exports__